import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import axios from 'axios';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from 'react-select';
import CustomSelect from '../../components/CustomSelectOut/CustomSelectOut';
import CustomInput from '../../components/CustomInput/CustomInput';

import {
  verifyLogin,
  apiList,
} from '../../helpers';
import SidePanel from '../../components/SidePanel/SidePanel';

const useStyles = makeStyles(() => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    '& + &': {
      marginTop: 20,
      paddingTop: 16,
      borderTop: '1px solid #EEF1F6',
    },
  },
  sectionTitle: {
    margin: '8px 0 4px',
    fontSize: 13,
    fontWeight: 600,
    color: '#5B6472',
  },
  checkBoxForm: {
    display: 'flex',
    marginLeft: 0,
    marginRight: 0,
    justifyContent: 'space-between',
  },
}));
const ACCESS_TYPES = ['IFSC', 'CITY', 'DISTRICT', 'ZONE', 'STATE', 'COUNTRY'];

const customStyles = {
  control: (styles) => ({
    ...styles,
    width: '100%',
    fontSize: 14,
  }),
  option: (styles) => ({
    ...styles,
    fontSize: 14,
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    fontSize: 10,
  }),
};

export default function OnBoardingDialog({
  open, handleClose, user,
}) {
  const classes = useStyles();
  const [newUser, setNewUser] = useState(user);
  const [userRoles, setUserRoles] = useState([]);
  const [accessLevelList, setAccessLevelList] = useState([]);
  const [accessType, setAccessType] = useState(user.accessType);
  const [checked, setChecked] = React.useState([]);
  const [resetPass, setResetPassword] = useState(false);
  const [autoPass, setAutoPass] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);

  const getPermissionConfig = (type, accessData) => {
    const { session } = verifyLogin();
    const config = { headers: { session } };
    axios.get(`${apiList.GET_ACCESS_CONFIG}?subscriberId=${user.subscriberId}`, config)
      .then((response) => {
        let data = response.data.data.paginate;
        switch (type) {
          case 0:
            data = data.map((item) => ({ value: item.ifscCode, label: item.branchName }));
            break;
          case 1:
            {
              const ids = data.map((o) => o.city);
              data = data.filter(({ city }, index) => !ids.includes(city, index + 1));
              data = data.map((item) => ({ value: item.city, label: item.city }));
            }
            break;
          case 2:
            {
              const ids = data.map((o) => o.district);
              data = data.filter(({ district }, index) => !ids.includes(district, index + 1));
              data = data.map((item) => ({ value: item.district, label: item.district }));
            }
            break;
          case 3:
            {
              const ids = data.map((o) => o.zone);
              data = data.filter(({ zone }, index) => !ids.includes(zone, index + 1));
              data = data.map((item) => ({ value: item.zone, label: item.zone }));
            }
            break;
          case 4:
            {
              const ids = data.map((o) => o.state);
              data = data.filter(({ state }, index) => !ids.includes(state, index + 1));
              data = data.map((item) => ({ value: item.state, label: item.state }));
            }
            break;
          case 5:
            {
              const ids = data.map((o) => o.country);
              data = data.filter(({ country }, index) => !ids.includes(country, index + 1));
              data = data.map((item) => ({ value: item.country, label: item.country }));
            }
            break;
          default:
            data = data.map((item) => ({ value: item.ifscCode, label: item.branchName }));
            break;
        }
        if (user.elementId) {
          const selectedData = data.filter(
            (el) => accessData.find((element) => element === el.value),
          );
          setSelectedOption(selectedData);
        }
        setAccessLevelList([...data]);
      })
      .catch((error) => {
        toast.error(`${error.response.data.error || error.response.data.message}`);
      });
  };

  useEffect(() => {
    if (user.elementId) {
      const { session } = verifyLogin();
      const config = { headers: { session } };
      axios.get(`${apiList.GET_USER_ACCESS_LEVEL}?userId=${user.elementId}`, config)
        .then((response) => {
          const data = response.data.data.paginate.map((item) => item.accessValue);
          setChecked([...data]);
          getPermissionConfig(accessType, data);
        })
        .catch(() => {
          getPermissionConfig(accessType, checked);
        });
    }
  }, []);

  useEffect(() => {
    const { session } = verifyLogin();
    const config = { headers: { session } };
    axios.get(`${apiList.VIEW_USERS_ROLES_API}?subscriberID=${user.subscriberId}`, config)
      .then((response) => {
        setUserRoles([...response.data.data]);
      })
      .catch(() => {

      });
  }, []);

  const saveUser = (key) => {
    key.preventDefault();
    const {
      subscriberId,
      elementId,
      userRoleId,
      firstName,
      lastName,
      phone,
      email,
      password,
      confirmPassword,
    } = newUser;

    const { session } = verifyLogin();
    const config = { headers: { session } };
    if (!selectedOption || selectedOption.length < 1) {
      toast.error('Please Set Access Level.');
      return;
    }

    const accessData = selectedOption.map((item) => item.value);
    const params = {
      subscriberId,
      userRoleId: Number(userRoleId),
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      phone: phone.trim(),
      email: email.trim(),
      accessType,
      accessData,
    };
    if (elementId) {
      if (resetPass) {
        params.password = password;
        params.confirmPassword = confirmPassword;
      }
      axios.patch(`${apiList.UPDATE_WEB_USERS_API}/${Number(elementId)}`, params, config)
        .then((response) => {
          toast.success(response.data.message);
          handleClose(true);
        })
        .catch((error) => {
          toast.error(`${error.response.data.error || error.response.data.message}`);
        });
    } else {
      params.userProduct = 1;
      if (!autoPass) {
        params.password = password;
        params.confirmPassword = confirmPassword;
      }
      axios.post(`${apiList.SAVE_WEB_USERS_API}`, params, config)
        .then((response) => {
          toast.success(response.data.message);
          handleClose(true);
        })
        .catch((error) => {
          toast.error(`${error.response.data.error || error.response.data.message}`);
        });
    }
  };

  // Same checks as the old two-step form: basic details first, then the
  // access level (inside saveUser).
  const handleSave = (key) => {
    const {
      subscriberId,
      userRoleId,
      firstName,
      lastName,
      email,
    } = newUser;
    if (subscriberId.length < 1
      || userRoleId.length < 1
      || firstName.length < 2
      || lastName.length < 2
      || email.length < 1) {
      toast.error('Please fill all the fields');
      return;
    }
    saveUser(key);
  };

  return (
    <SidePanel
      open={open}
      setOpen={(value) => { if (!value) handleClose(false); }}
      title={user.elementId ? 'Edit user' : 'Add user'}
      width={520}
      actionLabel={user.elementId ? 'Update' : 'Save'}
      handleSaveData={handleSave}
      body={(
        <>
          <section className={classes.section}>
            <h3 className={classes.sectionTitle}>Basic details</h3>
            <CustomSelect
              id='userRoleId'
              title='User Role'
              menuItems={userRoles.map((element) => (
                <option value={element.id} key={element.id}>{element.role}</option>
              ))}
              value={newUser.userRoleId}
              handleChange={(id) => {
                const obj = { userRoleId: id.target.value === '#78' ? '' : id.target.value };
                const data = { ...newUser, ...obj };
                setNewUser(data);
              }}
            />
            <CustomInput
              id='firstName'
              label='First Name'
              InputLabelProps={{
                shrink: true,
              }}
              value={newUser.firstName}
              onChange={(id) => {
                const obj = { firstName: id.target.value };
                const data = { ...newUser, ...obj };
                setNewUser(data);
              }}
            />
            <CustomInput
              id='lastName'
              label='Last Name'
              InputLabelProps={{
                shrink: true,
              }}
              value={newUser.lastName}
              onChange={(id) => {
                const obj = { lastName: id.target.value };
                const data = { ...newUser, ...obj };
                setNewUser(data);
              }}
            />
            <CustomInput
              id='phone'
              label='Mobile'
              type='number'
              InputLabelProps={{
                shrink: true,
              }}
              value={newUser.phone}
              onChange={(id) => {
                if (id.target.value.length < 11) {
                  const obj = { phone: id.target.value };
                  const data = { ...newUser, ...obj };
                  setNewUser(data);
                }
              }}
            />
            <CustomInput
              id='email'
              label='Email'
              InputLabelProps={{
                shrink: true,
              }}
              value={newUser.email}
              onChange={(id) => {
                const obj = { email: id.target.value };
                const data = { ...newUser, ...obj };
                setNewUser(data);
              }}
            />
            {!newUser.elementId ? (
              <FormControlLabel
                className={classes.checkBoxForm}
                control={(
                  <Checkbox
                    checked={autoPass}
                    onChange={(event) => {
                      const obj = { password: null, confirmPassword: null };
                      const data = { ...newUser, ...obj };
                      setNewUser(data);
                      setAutoPass(event.target.checked);
                    }}
                  />
                )}
                label='Auto Generate Password'
                labelPlacement='start'
              />
            ) : null}
            {newUser.elementId ? (
              <FormControlLabel
                className={classes.checkBoxForm}
                control={(
                  <Checkbox
                    checked={resetPass}
                    onChange={(event) => setResetPassword(event.target.checked)}
                  />
                )}
                label='Reset Password'
                labelPlacement='end'
              />
            ) : null}
            {((!newUser.elementId && !autoPass) || (newUser.elementId && resetPass)) && (
            <CustomInput
              id='password'
              label='Password'
              type='password'
              InputLabelProps={{
                shrink: true,
              }}
              value={newUser.password}
              onChange={(id) => {
                const obj = { password: id.target.value };
                const data = { ...newUser, ...obj };
                setNewUser(data);
              }}
            />
            )}
            {((!newUser.elementId && !autoPass) || (newUser.elementId && resetPass)) && (
            <CustomInput
              id='confirmPassword'
              label='Confirm Password'
              type='password'
              InputLabelProps={{
                shrink: true,
              }}
              value={newUser.confirmPassword}
              onChange={(id) => {
                const obj = { confirmPassword: id.target.value };
                const data = { ...newUser, ...obj };
                setNewUser(data);
              }}
            />
            )}
          </section>
          <section className={classes.section}>
            <h3 className={classes.sectionTitle}>Access</h3>
            <CustomSelect
              id='accessType'
              title='Access Type'
              menuItems={ACCESS_TYPES.map((element, i) => (
                <option value={i} key={element}>{element}</option>
              ))}
              value={accessType}
              handleChange={(id) => {
                setAccessType(id.target.value);
                setSelectedOption(null);
                setChecked([]);
                if (id.target.value !== '#78') {
                  getPermissionConfig(Number(id.target.value), checked);
                } else {
                  setAccessLevelList([]);
                }
              }}
            />
            {accessType > -1 ? (
              <Select
                isMulti
                value={selectedOption}
                onChange={setSelectedOption}
                styles={customStyles}
                closeMenuOnSelect={false}
                options={accessLevelList}
              />
            ) : null}
          </section>
        </>
      )}
    />
  );
}
